module.exports = __webpack_public_path__ + "d25caacd637ab56a657f9d7b565d9207.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-regular-webfont.woff
 ** module id = ./src/styles/fonts/lato/lato-regular-webfont.woff
 ** module chunks = 0
 **/